// extracted by mini-css-extract-plugin
module.exports = {"neRegion":"NamingExamples_neRegion__2uj40","neRegionTitle":"NamingExamples_neRegionTitle__12Cy0","buyRequestExample":"NamingExamples_buyRequestExample__3twp7"};